import { render } from "./BookingPage.vue?vue&type=template&id=2497be42&scoped=true"
import script from "./BookingPage.vue?vue&type=script&lang=js"
export * from "./BookingPage.vue?vue&type=script&lang=js"

import "./BookingPage.vue?vue&type=style&index=0&id=2497be42&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/gestionale-simba-2.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2497be42"]])

export default __exports__